import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const VerifyEmail = lazy(() => import("@/pages/VerifyEmail"));

export const Route = createFileRoute("/verify-email")({
  component: VerifyEmail,
});
